/** @format */

export default {
	SET_AUTHORIZATIONS: 'SET_AUTHORIZATIONS',
	SET_AUTHORIZATION: 'SET_AUTHORIZATION',
	SET_ERROR_FOR_AUTHORIZATIONS: 'SET_ERROR_FOR_AUTHORIZATIONS',
	SET_AUTHORIZATIONS_SUMMARY: 'SET_AUTHORIZATIONS_SUMMARY',
	SET_ERROR_FOR_AUTHORIZATIONS_SUMMARY:
		'SET_ERROR_FOR_AUTHORIZATIONS_SUMMARY',
	SET_IS_REQUESTING_AUTHORIZATION: 'SET_IS_REQUESTING_AUTHORIZATION',
};
